import debug from 'debug';
import { config } from '/src/config';

export const logger = (namespace: string) => debug(`${config.logs.rootNamespace}:${namespace}`);
